import {apiurl} from '@/services/config'

const API_URL = apiurl + '/backoffice/irmainfo'

export const RunningTextService = {
    list,
    hapus,
    add,
    edit

}

async function list () {
    const response = await fetch(API_URL, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('token')
        }
    })
    return await handleResponse(response)
}

async function add (postdata) {
    var data = JSON.stringify( postdata )

    return fetch(API_URL, {
        method: 'POST',
        body: data,
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('token')
        }
    }).then(handleResponse)
        .then(data => {
            return data
        })
}

async function edit (postdata) {
    var data = JSON.stringify( postdata )

    return fetch(API_URL, {
        method: 'PATCH',
        body: data,
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('token')
        }
    }).then(handleResponse)
        .then(data => {
            return data
        })
}

async function hapus (id) {
    return fetch(API_URL +"/"+ id, {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('token')
        }
    }).then(handleResponse)
        .then(data => {
            return data
        })
}



function handleResponse (response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text)

        if (!data.success) {
            if (response.status === 401) {
                console.log("CALL LOGOUT");
                localStorage.setItem('token',null);
                localStorage.clear();
                location.reload(true)
            }
            const error = (data && data.msg) || response.statusText
            return Promise.reject(error)
        }
        return data
    })
}
